import { Component } from '@verndale/core';
import Swiper, { Navigation, Pagination } from 'swiper';
import { DESKTOP, TABLET } from '../utils/breakpoints';
import { setParentBlockSize } from '../utils/dom';

Swiper.use([Navigation, Pagination]);

class Module extends Component {
  constructor(el) {
    super(el);
    this.initSwiper();
  }
  setupDefaults() {
    this.dom = {
      $headings: this.el.querySelector('.listing-masthead__heading'),
      $swiperContainer: this.el.querySelector('.swiper-container'),
      $swiperPagination: this.el.querySelector('.slider__pagination'),
      $cards: Array.from(this.el.querySelectorAll('.swiper-slide')),
      $swiperNext: this.el.querySelector('.card-carousel__next-button'),
      $swiperBack: this.el.querySelector('.card-carousel__back-button'),
      $topContent: this.el.querySelector('.card-carousel__top-content'),
      $background: this.el.querySelector('.card-carousel__background')
    };

    this.slidesNumber = this.dom.$cards.length;

    if (this.dom.$background) {
      setParentBlockSize(this.dom.$topContent, this.dom.$background);
    }
  }

  initSwiper() {
    const renderCustom = (_swiper, current) => {
      let str = '';

      if (window.matchMedia(`(max-width: ${TABLET}px)`).matches) {
        str = `${current} of ${this.slidesNumber}`;
        if (this.slidesNumber > 1) {
          this.dom.$swiperNext.style.display = 'block';
          this.dom.$swiperBack.style.display = 'block';
        } else {
          this.dom.$swiperNext.style.display = 'none';
          this.dom.$swiperBack.style.display = 'none';
        }
      } else {
        str = `${_swiper.activeIndex + 1}-${_swiper.activeIndex + _swiper.params.slidesPerView} of ${this.slidesNumber}`;

        if (_swiper.params.slidesPerView < this.slidesNumber) {
          this.dom.$swiperNext.style.display = 'block';
          this.dom.$swiperBack.style.display = 'block';
        } else {
          this.dom.$swiperNext.style.display = 'none';
          this.dom.$swiperBack.style.display = 'none';
        }
      }
      this.swiperAccesibility(_swiper.activeIndex, _swiper.activeIndex + _swiper.params.slidesPerView);

      return str;
    };

    this.dom.$swiperNext.setAttribute('aria-label', window.acadian?.labels?.nextArrow);
    this.dom.$swiperBack.setAttribute('aria-label', window.acadian?.labels?.prevArrow);

    this.el.style = '--slider-center: start';

    if (this.dom.$cards.length <= 3) {
      switch (this.dom.$cards.length) {
        case 1:
        case 2:
          this.slidesTablet = this.dom.$cards.length;
          this.slidesDesktop = this.dom.$cards.length;
          this.el.style = '--slider-center: center';
          break;
        case 3:
          this.slidesTablet = 2;
          this.slidesDesktop = 3;
      }

      this.dom.$cards.forEach((card) => {
        card.style.maxWidth = '600px';
      });
    } else {
      this.slidesTablet = 2;
      this.slidesDesktop = 3;
    }

    if (this.dom.$cards.length === 1) {
      this.spaceBetween = 0;
    } else {
      this.spaceBetween = 20;
    }

    this.swiper = new Swiper(this.dom.$swiperContainer, {
      slidesPerGroup: 1,
      slidesPerView: 1,
      watchOverflow: true,
      spaceBetween: this.spaceBetween,
      breakpoints: {
        [TABLET]: {
          slidesPerGroup: this.slidesTablet,
          slidesPerView: this.slidesTablet
        },
        [DESKTOP]: {
          slidesPerGroup: this.slidesDesktop,
          slidesPerView: this.slidesDesktop
        }
      },
      navigation: {
        nextEl: this.dom.$swiperNext,
        prevEl: this.dom.$swiperBack
      },
      pagination: {
        el: this.dom.$swiperPagination,
        type: 'custom',
        modifierClass: '',
        renderCustom
      }
    });
  }

  swiperAccesibility(start, finish) {
    Array.from(this.dom.$cards).forEach((element, index) => {
      element.style.visibility = 'hidden';
      if (index >= start && index < finish) {
        element.style.visibility = 'visible';
      }
    });
  }
}

export default Module;
